import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class SyncerService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Wake up syncer
     * @returns any Syncer is waking up.
     * @throws ApiError
     */
    syncerWakeUp({ orgId, redirectTo, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/apps/syncer/wake-up', path: {
                'orgId': orgId,
            }, query: {
                'redirectTo': redirectTo,
            }, errors: {
                302: `Redirect to loading screen.`,
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get syncer status
     * @returns SyncerStatus Syncer status.
     * @throws ApiError
     */
    syncerStatus({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/apps/syncer/status', path: {
                'orgId': orgId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=SyncerService.js.map